























































import Vue, { PropType } from "vue";
import log from "loglevel";

declare var paypal: any;

export interface purchaseSettlementPaypalProps {
  locale: string;
  lang: any;
  session: string;
  itemName: string;
  itemServiceType: string;
  itemPrice: number;
  currency: string;
  sdkUrl: string;
  clientToken: string;
  errorUrl: string;
  postPurchaseSettlementPaypalOrder: any;
  postPurchaseSettlementPaypalApprove: any;
  updateIsBusy: any;
  isBusy: boolean;
  showAnnotation: boolean;
}

export default Vue.extend({
  name: "vc-purchase-settlement-paypal",
  data() {
    return {
      itemImgPath: {
        // Stripeの規定のため、V4から正方形に変更
        activation_code_exv4:
          "/view/img/components/PurchaseSettlementPaypal/logo_paint_v4_ex.png",
        activation_code_prov4:
          "/view/img/components/PurchaseSettlementPaypal/logo_paint_v4_pro.png",
        activation_code_exv3:
          "/view/img/components/PurchaseSettlementPaypal/logo_paint_v3_ex.png",
        activation_code_prov3:
          "/view/img/components/PurchaseSettlementPaypal/logo_paint_v3_pro.png",
        activation_code_ex_12month:
          "/view/img/components/PurchaseSettlementPaypal/logo_paint_ex.png",
        activation_code_pro_12month:
          "/view/img/components/PurchaseSettlementPaypal/logo_paint_pro.png",
        activation_code_ex_12month_webtoon_canvas:
          "/view/img/components/PurchaseSettlementPaypal/logo_paint_ex.png",
        activation_code_pro_12month_webtoon_canvas:
          "/view/img/components/PurchaseSettlementPaypal/logo_paint_pro.png",
        activation_code_ex_updatepass:
          "/view/img/components/PurchaseSettlementPaypal/logo_paint_ex.png",
        activation_code_pro_updatepass:
          "/view/img/components/PurchaseSettlementPaypal/logo_paint_pro.png",
        activation_code_pro_webtoon:
          "/view/img/components/PurchaseSettlementPaypal/logo_paint_pro.png",
        gold_charge_code_1000:
          "/view/img/components/PurchaseSettlementPaypal/logo_gold_charge_code.png",
        gold_charge_code_5000:
          "/view/img/components/PurchaseSettlementPaypal/logo_gold_charge_code.png",
        gold_charge_code_10000:
          "/view/img/components/PurchaseSettlementPaypal/logo_gold_charge_code.png"
      },
      errorMessage: ""
    };
  },
  props: {
    locale: {
      type: String as PropType<purchaseSettlementPaypalProps["locale"]>,
      default: ""
    },
    lang: {
      type: Object as PropType<purchaseSettlementPaypalProps["lang"]>,
      default: () => {}
    },
    session: {
      type: String as PropType<purchaseSettlementPaypalProps["session"]>,
      default: ""
    },
    itemName: {
      type: String as PropType<purchaseSettlementPaypalProps["itemName"]>,
      default: ""
    },
    itemServiceType: {
      type: String as PropType<
        purchaseSettlementPaypalProps["itemServiceType"]
      >,
      default: ""
    },
    itemPrice: {
      type: Number as PropType<purchaseSettlementPaypalProps["itemPrice"]>,
      default: 0
    },
    currency: {
      type: String as PropType<purchaseSettlementPaypalProps["currency"]>,
      default: ""
    },
    sdkUrl: {
      type: String as PropType<purchaseSettlementPaypalProps["sdkUrl"]>,
      default: ""
    },
    clientToken: {
      type: String as PropType<purchaseSettlementPaypalProps["clientToken"]>,
      default: ""
    },
    errorUrl: {
      type: String as PropType<purchaseSettlementPaypalProps["errorUrl"]>,
      default: ""
    },
    // actionsToProps
    postPurchaseSettlementPaypalOrder: {
      type: Function as PropType<
        purchaseSettlementPaypalProps["postPurchaseSettlementPaypalOrder"]
      >,
      default: () => {}
    },
    postPurchaseSettlementPaypalApprove: {
      type: Function as PropType<
        purchaseSettlementPaypalProps["postPurchaseSettlementPaypalApprove"]
      >,
      default: () => {}
    },
    updateIsBusy: {
      type: Function as PropType<purchaseSettlementPaypalProps["updateIsBusy"]>,
      default: () => {}
    },
    isBusy: {
      type: Boolean as PropType<purchaseSettlementPaypalProps["isBusy"]>,
      default: false
    },
    showAnnotation: {
      type: Boolean as PropType<
        purchaseSettlementPaypalProps["showAnnotation"]
      >,
      default: false
    }
  },
  mounted() {
    const script = document.createElement("script");

    script.src = this.sdkUrl;
    script.setAttribute("data-client-token", this.clientToken);
    script.onload = this.onLoadScript;

    document.body.appendChild(script);
  },
  methods: {
    async onLoadScript() {
      paypal
        .Buttons({
          createOrder: this.createOrderCallback,
          onApprove: this.onApproveCallback,
          onError: this.onError,
          style: {
            shape: "rect",
            layout: "vertical",
            color: "gold",
            label: "paypal"
          },
          message: {
            amount: this.itemPrice
          }
        })
        .render(this.$refs.purchase_button);
    },
    async createOrderCallback() {
      this.updateIsBusy(true);
      this.errorMessage = "";
      try {
        const res = await this.postPurchaseSettlementPaypalOrder({
          session: this.session
        });

        return res.order_id;
      } catch (error) {
        log.error(error);

        const response =
          typeof error.json === "function" ? await error.json() : error;
        log.error(response);

        if (response.code === "SETTLEMENT_PAYPAL_ERROR") {
          this.errorMessage = response.data.error_message;
        } else {
          window.location.href = this.errorUrl + "?type=default_error";
        }
        throw error;
      } finally {
        this.updateIsBusy(false);
      }
    },
    async onApproveCallback(data: any, actions: any) {
      try {
        const res = await this.postPurchaseSettlementPaypalApprove({
          session: this.session,
          order_id: data.orderID
        });
        window.location.href = res.returnUrl;
      } catch (error) {
        log.error(error);

        const response =
          typeof error.json === "function" ? await error.json() : error;
        log.error(response);

        if (response.code === "SETTLEMENT_PAYPAL_ERROR") {
          this.errorMessage = response.data.error_message;
        } else {
          window.location.href = this.errorUrl + "?type=default_error";
        }
        throw error;
      } finally {
        this.updateIsBusy(false);
      }
    },
    async onError(error: any) {
      log.error(error);
    }
  }
});
